export default "__VITE_ASSET__C$veXxnO__"